import { useLayoutEffect } from "react";

export function useHeaderOffset(id = "app-header") {
  useLayoutEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    
    const setHeaderHeight = () => {
      const height = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty("--app-header-h", `${height}px`);
    };
    
    // Set initial height
    setHeaderHeight();
    
    // Watch for size changes
    const resizeObserver = new ResizeObserver(setHeaderHeight);
    resizeObserver.observe(el);
    
    // Also update on scroll (in case of sticky behavior changes)
    window.addEventListener("scroll", setHeaderHeight, { passive: true });
    
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("scroll", setHeaderHeight);
    };
  }, [id]);
}